import { useState, useEffect, useRef } from "react";

// Pitido corto con Web Audio (sin archivo de sonido). Lo usan la pantalla de
// Cocina (pedido nuevo) y el aviso al mozo de la barra superior (plato listo).
function playTones(context, tones) {
  tones.forEach(([frequency, delay]) => {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.frequency.value = frequency;
    gain.gain.value = 0.25;
    oscillator.connect(gain);
    gain.connect(context.destination);
    const start = context.currentTime + delay;
    oscillator.start(start);
    oscillator.stop(start + 0.18);
  });
}

// Dos tonos distintos para que cocina y mozo no confundan sus avisos si están
// cerca: subiendo = pedido nuevo en cocina; bajando = plato listo para llevar.
export const BEEP_NEW_ORDER = [
  [880, 0],
  [1175, 0.25],
];
export const BEEP_READY = [
  [1175, 0],
  [880, 0.25],
];

// El navegador solo deja sonar después de que alguien toque la página. Se
// intenta al montar (con la app instalada, Chrome suele permitirlo sin tocar
// nada) y, si no, con el primer toque en cualquier parte.
export function useBeep(tones = BEEP_NEW_ORDER) {
  const contextRef = useRef(null);
  const [soundOn, setSoundOn] = useState(false);

  const getContext = () => {
    if (contextRef.current) return contextRef.current;
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return null;
    try {
      contextRef.current = new AudioContext();
    } catch (error) {
      return null;
    }
    return contextRef.current;
  };

  useEffect(() => {
    const unlock = () => {
      const context = getContext();
      if (!context) return;
      context
        .resume()
        .then(() => setSoundOn(context.state === "running"))
        .catch(() => {});
    };
    unlock();
    document.addEventListener("pointerdown", unlock);
    return () => document.removeEventListener("pointerdown", unlock);
  }, []);

  const beep = () => {
    const context = contextRef.current;
    if (context && context.state === "running") playTones(context, tones);
  };

  // Botón "Activar sonido": desbloquea (lo hace el toque mismo) y suena una
  // vez para confirmar el volumen.
  const testBeep = () => {
    const context = getContext();
    if (!context) return;
    context
      .resume()
      .then(() => playTones(context, tones))
      .catch(() => {});
  };

  return { soundOn, beep, testBeep };
}
